export const maxRecommendationLength = 1000;
export const maxDiagnosisLength = 700;
export const hoursForErrors = 24;
